import { lazy, Suspense } from 'react';

import { Routes, Route } from 'react-router';

import { PlayerPage } from '@/pages/player';
import { APP_ROUTES } from '@/shared/config';
import { LoadingScreen } from '@/shared/ui';

const NotFoundPage = lazy(() => import('@/pages/not-found'));

export function Router() {
  return (
    <Suspense fallback={<LoadingScreen />}>
      <Routes>
        <Route index path={APP_ROUTES.root} element={<PlayerPage />} />
        <Route path={APP_ROUTES.catchAll} element={<NotFoundPage />} />
      </Routes>
    </Suspense>
  );
}
